var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandAtlassianBitbucketStyleWhite = function SvgBrandAtlassianBitbucketStyleWhite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandAtlassianBitbucketStyleWhite__paint0_linear_118_367297)",
    d: "M22.77 9.113h-6.93l-1.163 6.79h-4.8L4.209 22.63a1 1 0 0 0 .646.244h15.043a.74.74 0 0 0 .738-.62z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.477 2.149a.738.738 0 0 0-.739.857l3.135 19.03a1 1 0 0 0 .336.594c.18.155.409.242.646.244l5.82-6.971h-.817l-1.28-6.79H22.77l.997-6.104a.738.738 0 0 0-.738-.856z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_BrandAtlassianBitbucketStyleWhite__paint0_linear_118_367297",
    x1: 23.69,
    x2: 15.794,
    y1: 12.129,
    y2: 21.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandAtlassianBitbucketStyleWhite);
export { ForwardRef as ReactComponent };